import React from 'react';
import * as classes from './SkipLink.module.scss';

export interface ISkipLinkProps extends React.PropsWithChildren {
    target: string;
}

export const SkipLink: React.FunctionComponent<ISkipLinkProps> = props => (
    <a href={`#${props.target}`} className={classes.link}>{props.children}</a>
);
